import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Redirect, Route, Switch, withRouter,
} from 'react-router-dom';
import {
  compose, filter, map, isEmpty,
} from 'lodash/fp';
import { sendPageLog } from '../../common/services';
import { Layout, RouteWithSubroutes } from '../components';
import routes from '../routes';
import AppBar from './AppBar';
import PrivateRoute from './PrivateRoute';

const Routes = ({ history }) => {
  const info = useSelector(state => state.user.info);

  useEffect(() => {
    const unlisten = history.listen(({ pathname, state = {} }) => {
      if (!isEmpty(info.user_id)) {
        sendPageLog({
          id: info.user_id,
          role: info.role,
          grade: info.grade || 0,
          client_time: new Date().getTime(),
          app_version: navigator.appVersion,
          os_version: null,
          ip: null,
          language: info.language || navigator.language,
          country: info.country_code || navigator.language,
          device: 'web.event',
          cur_page: pathname || '',
          prev_page: state.from || '',
        });
      }
    });

    return unlisten;
  }, [history, info]);

  return (
    <Switch>
      <Route path="/schools/:sid">
        <Layout>
          <AppBar />
          <Switch>
            {compose(
              map(({ hasSidebar, isPrivate, ...otherProps }) => (
                isPrivate
                  ? <PrivateRoute {...otherProps} />
                  : <RouteWithSubroutes {...otherProps} />
              )),
              filter(route => route.hasSidebar),
            )(routes)}
            <Redirect to="/not-found" />
          </Switch>
        </Layout>
      </Route>
      {compose(
        map(({ hasSidebar, isPrivate, ...otherProps }) => (
          isPrivate
            ? <PrivateRoute {...otherProps} />
            : <RouteWithSubroutes {...otherProps} />
        )),
        filter(route => !route.hasSidebar),
      )(routes)}
      <Redirect from="/" to="/schools" exact />
      <Redirect from="/ko" to="/schools" exact />
      <Redirect to="/not-found" />
    </Switch>
  );
};

Routes.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func,
  }).isRequired,
  location: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      sid: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default withRouter(Routes);
